<template>
    <a-layout class="main-layout">
        <global-header />
        <a-layout class="layout">
            <a-layout-sider class="navigation" :width="58">
                <div class="modules">
                    <ul class="route">
                        <li class="item" :class="{ active: sidebar_key === 'dashboard' }" @click="$router.push('/')">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#icon-home3" />
                            </svg>
                        </li>

                        <template v-for="item in data_module">
                            <a-tooltip placement="right" :key="item.as" v-if="item.visible">
                                <template slot="title">{{ item.name }}</template>
                                <li class="item" :class="{ active: sidebar_key === item.as }" @click="$router.push(item.url)">
                                    <svg class="icon" aria-hidden="true">
                                        <use :xlink:href="item.icon" />
                                    </svg>
                                </li>
                            </a-tooltip>
                        </template>

                        <!-- <li class="item">
                            <a-popover title="快捷访问" placement="right" overlayClassName="my-popover">
                                <template slot="content">
                                    <a-menu class="my-menu" v-if="data_shortcut.length">
                                        <a-menu-item v-for="e in data_shortcut" :key="e.id" @click="$router.push(e.url)" class="short-item">
                                            <span class="s-t">{{ e.name }}</span>
                                            <a-icon class="close" type="close-circle" @click="(event) => delete_shortcut(event, e.id)" />
                                        </a-menu-item>
                                    </a-menu>

                                    <div v-else>
                                        <a-empty style="padding-top: 24px;padding-bottom: 24px;" description="尚未添加快捷链接" />
                                    </div>
                                </template>
                                <a-icon type="pushpin" />
                            </a-popover>
                        </li> -->
                    </ul>
                </div>

                <!-- <div class="action">
                    <div class="divider"></div>
                    <div class="profile pointer">
                        <a-popover :title="profile.name" placement="right" overlayClassName="my-popover">
                            <template slot="content">
                                <a-menu class="my-menu">
                                    <a-menu-item @click="$router.push('/profile')"><a-icon type="user" />个人中心</a-menu-item>
                                    <a-menu-divider />
                                    <a-menu-item @click="on_logout"> <a-icon type="logout" />退出登录 </a-menu-item>
                                </a-menu>
                            </template>
                            <a-avatar
                                :size="36"
                                :src="profile.avatar"
                                style="box-shadow: 0 1px 2px 0 #3c40434d, 0 1px 3px 1px #3c404326;background: #fff;"
                            />
                        </a-popover>
                    </div>
                    <ul class="route">
                        <a-tooltip placement="right">
                            <template slot="title">系统设置</template>
                            <li
                                class="item"
                                @click="$router.push('/setting')"
                                :class="{ active: sidebar_key === 'setting' }"
                                v-if="permissible.indexOf('setting') > -1"
                            >
                                <a-icon type="setting" />
                            </li>
                        </a-tooltip>
                    </ul>
                </div> -->
            </a-layout-sider>

            <a-layout-content class="context">
                <router-view />

                <!-- 录入客户 -->
                <member_create />

                <!-- 跟进客户 -->
                <modal_revisit />

                <!-- 查看客户 -->
                <member_show />

                <!-- 快捷访问 -->
                <modal_shortcut />
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>
<script>
    import member_create from "./member/components/modal_create";
    import member_show from "./member/components/modal_show";
    import modal_revisit from "./components/modal_revisit";
    import modal_shortcut from "./components/modal_shortcut";
    export default {
        components: {
            member_create,
            modal_revisit,
            member_show,
            modal_shortcut,
        },
        computed: {
            profile() {
                return this.$store.state.profile || {};
            },
            sidebar_key() {
                return this.$store.state.sidebar_key;
            },
            data_shortcut() {
                return this.$store.state.shortcuts;
            },
            data_module() {
                return this.$store.state.modules;
            },
        },
    };
</script>

<style lang="less" scoped>
    .main-layout {
        overflow: hidden;
        height: 100%;

        .layout {
            background: #fff;
            top: 48px;
            position: absolute;
            width: 100%;
            bottom: 0;
            overflow: hidden;
            .navigation {
                bottom: 28px;
                left: 0px;
                position: fixed;
                top: 48px;
                z-index: 1;
                -webkit-box-align: center;
                align-items: center;
                box-sizing: border-box;
                flex-shrink: 0;
                transition: background-color 0.3s cubic-bezier(0.2, 0, 0, 1) 0s, color 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
                height: calc(100vh - 0px);
                background-color: #fafafa;
                // color: #bfbfbf;
                // fill: #bfbfbf;
                box-shadow: inset -5px 0 5px -5px #0000001a;
                overflow: hidden;
                /deep/.ant-layout-sider-children {
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;

                    .action {
                        text-align: center;
                        .divider {
                            width: 50%;
                            height: 0.5px;
                            background: #757575;
                            margin-bottom: 24px;
                            margin-left: auto;
                            margin-right: auto;
                        }
                        .profile {
                            margin-left: auto;
                            margin-right: auto;
                            margin-bottom: 24px;
                        }
                    }
                    .route {
                        .item {
                            text-align: center;
                            height: 58px;
                            line-height: 58px;
                            .icon {
                                width: 24px;
                                height: 24px;
                                vertical-align: middle;
                                border-radius: 5px;
                            }
                            &:first-child {
                                margin-top: 0;
                            }
                            &:hover,
                            &.active {
                                cursor: pointer;
                                background: #ffffff;
                                box-shadow: 0px 0px 5px 0px #0000001a;
                                .icon {
                                    transition: all 0.3s;
                                    color: #111;
                                }
                            }
                        }
                    }
                }
            }
            .context {
                position: relative;
                position: relative;
                margin-left: 58px;
            }
        }
    }
</style>
